import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import { getRouteByActivityType } from 'src/app/board/activity/activity-shared/activity-shared-routes';
import { RouteActivityType } from 'src/app/board/activity/activity.constants';

export const activityBenefitsRoutes: MenuInterface[] = [
    {
        code: 'BenefitParameters',
        route: getRouteByActivityType('ActivityParameters', RouteActivityType.Benefits)
    },
    {
        code: 'BenefitConfigPermanences',
        route: getRouteByActivityType('PermanencesSettings', RouteActivityType.Benefits)
    },
    {
        code: 'BenefitConfigActions',
        route: getRouteByActivityType('GroupedActions', RouteActivityType.Benefits)
    },
    {
        code: 'BenefitCatalog',
        route: getRouteByActivityType('Catalog', RouteActivityType.Benefits)
    },
    {
        code: 'BenefitConfigFormsFields',
        route: getRouteByActivityType('FormField', RouteActivityType.Benefits)
    },
    {
        code: 'BenefitConfigStatusParameters',
        route: getRouteByActivityType('StatusParameters', RouteActivityType.Benefits)
    },
    {
        code: 'BenefitConfigForms',
        route: getRouteByActivityType('Forms', RouteActivityType.Benefits)
    },
    {
        code: 'BenefitConfigStatusParameters',
        route: getRouteByActivityType('StatusParameters', RouteActivityType.Benefits)
    },
    {
        code: 'BenefitSuppliersFreeOrdersList',
        route: getRouteByActivityType('SuppliersFreeOrdersList', RouteActivityType.Benefits)
    },
    {
        code: 'BenefitSuppliersFreeInvoicesList',
        route: getRouteByActivityType('SuppliersFreeInvoicesList', RouteActivityType.Benefits),
    },
    {
        code: 'BenefitBeneficiariesFreeOrdersList',
        route: getRouteByActivityType('BeneficiariesFreeOrdersList', RouteActivityType.Benefits)
    },
    {
        code: 'BenefitBeneficiariesFreeInvoicesList',
        route: getRouteByActivityType('BeneficiariesFreeInvoicesList', RouteActivityType.Benefits),
    },
    {
        code: 'BenefitFreeEntriesModelsList',
        route: getRouteByActivityType('FreeEntriesModelsList', RouteActivityType.Benefits)
    },
    {
        code: 'BenefitRecordManagment',
        route: [
            {
                content: 'activity/benefits/records/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'BenefitRefundCertificatesList',
        route: [
            {
                content: 'activity/benefits/refunds/certificates/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'BenefitPacSuppliersSalesList',
        route: [
            {
                content: 'activity/benefits/pac/orders/suppliers/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'BenefitPacBeneficiariesSalesList',
        route: [
            {
                content: 'activity/benefits/pac/orders/beneficiaries/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'BenefitGiftSalesList',
        route: [
            {
                content: 'activity/benefits/gifts/orders/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'BenefitGiftDelivery',
        route: [
            {
                content: 'activity/benefits/gifts/deliveries/deliver',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'BenefitGiftDeliveriesList',
        route: [
            {
                content: 'activity/benefits/gifts/deliveries/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'BenefitGiftInvoicesList',
        route: [
            {
                content: 'activity/benefits/gifts/invoices/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'BenefitPrintForms',
        route: [
            {
                content: 'activity/benefits/prints/forms',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'BenefitPrintBudgetCommitment',
        route: [
            {
                content: 'activity/benefits/prints/budgets-commitment',
                focus: 'empty'
            }, 'content'
        ]
    },
];
